import { ENotificationTypesDB, TAnimalUpdateConfig } from './property.types';

// FE enum mirroring BE PropertyManagerPermission keys
export enum ECapabilityKey {
  APPROVE_AND_DENY_ANIMALS = 'APPROVE_AND_DENY_ANIMALS',
  ADD_EDIT_ANIMALS = 'ADD_EDIT_ANIMALS',
  RETRACT_AND_REAPPLY_ANIMALS = 'RETRACT_AND_REAPPLY_ANIMALS',
  IMPORT_RESIDENTS = 'IMPORT_RESIDENTS',
  RESIDENCY_EDITING = 'RESIDENCY_EDITING',
  CREATE_AND_EDIT_PROPERTIES = 'CREATE_AND_EDIT_PROPERTIES',
  DELETE_PROPERTIES = 'DELETE_PROPERTIES',
  CREATE_AND_EDIT_ACCESS_CODE = 'CREATE_AND_EDIT_ACCESS_CODE',
  ANIMAL_REQUIREMENTS_AND_RESTRICTIONS = 'ANIMAL_REQUIREMENTS_AND_RESTRICTIONS',
  AUTOMATED_REPORTING_ACCESS = 'AUTOMATED_REPORTING_ACCESS',
  TEAM_MEMBERS_ACCESS = 'TEAM_MEMBERS_ACCESS',
  DELETE_TEAM_MEMBERS = 'DELETE_TEAM_MEMBERS',
  COMPLAINTS_MANAGEMENT = 'COMPLAINTS_MANAGEMENT',
  ACCESS_TO_BILLING_METHOD = 'ACCESS_TO_BILLING_METHOD',
}

// Permission type — single enum shared between FE and BE
export enum EPermissionType {
  FULL = 'FULL',
  READ = 'READ',
  CUSTOM_INDIVIDUAL = 'CUSTOM_INDIVIDUAL',
  CUSTOM_SHARED = 'CUSTOM_SHARED',
}

export type TCapabilities = Record<ECapabilityKey, boolean>;

// Unified notification key — includes PRIMARY_CONTACT (FE-only, split in converter for BE)
export type TNotificationKey = ENotificationTypesDB | 'PRIMARY_CONTACT';
export const PRIMARY_CONTACT_KEY = 'PRIMARY_CONTACT' as const;

export type TPMPermissionsDB = {
  id: string;
  name?: string;
  permissions: string[];
  notificationTypes?: string[];
  isPrimaryContact?: boolean;
  positions?: string[];
  linkedMembers?: { id: string; name: string }[];
  type: EPermissionType;
  animalUpdateConfig?: TAnimalUpdateConfig | null;
  isReportingEnabled?: boolean;
};

// --- FE UI types ---

export type TUserPermissionsUI =
  | { type: EPermissionType.FULL }
  | { type: EPermissionType.READ }
  | { type: EPermissionType.CUSTOM_INDIVIDUAL; setId?: string; capabilities: TCapabilities }
  | { type: EPermissionType.CUSTOM_SHARED; setId: string; setName: string; capabilities: TCapabilities };

export type TCustomSharedPermissionSetUI = {
  id: string;
  name: string;
  capabilities: TCapabilities;
  positions: { value: string; label: string }[];
  notifications: TNotificationKey[];
  linkedMembers?: { id: string; name: string }[];
  animalUpdateConfig?: TAnimalUpdateConfig | null;
  isReportingEnabled?: boolean;
};

export type TBulkAssignPermissionsUI = {
  propertyManagerIds: string[];
  permissions: TUserPermissionsUI;
  notifications: TNotificationKey[];
};

export type TUpdateTmPermissionsUI = {
  propertyManagerId: string;
  permissions: TUserPermissionsUI;
};
